import { HomeContainer, MigrationAlertContainer, UnreadTasksContainer } from 'src/containers/Home';
import { Main } from 'src/components/Layout';

const HomePage = () => {
  return (
    <Main title="Home">
      <div className="container mx-auto">
        <MigrationAlertContainer />
        <HomeContainer />
        <UnreadTasksContainer />
      </div>
    </Main>
  );
};

export default HomePage;
